import React, { useEffect, useRef, useState } from "react";
import logo from "../assets/images/navlogo.png"; // Import your logo image
import { Link, useLocation, useNavigate } from "react-router-dom";
// import notificationIcon from '../assets/notification.svg'; // Import your notification icon image
import { MobileSideBar } from "./MobileSideBar";
import { useAppSelector } from "@/hooks/hook";
import { useDispatch } from "react-redux";
import { logout, upadateApplicationAccess, upadateFuturePayments } from "@/redux/slices/userSlice";
import { Bars } from "@/utils/svgs";
import ChangesAlert from "@/components/alert/ChangesAlert";
import { formStateChange } from "@/redux/slices/formSlice";
import { RiLockPasswordLine } from "react-icons/ri";
import { HiOutlineLogout } from "react-icons/hi";
import NotificationBell from "@/components/notifications/NotificationBell";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { BookingNotification, NotificationCount } from "@/interfaces/Notifcations";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { currentBusinessSave } from "@/redux/slices/businessSlice";
import { Button } from "@thdinc/hpf-shared";
interface User {
  first_name: string;
  last_name: string;
  roles: string;
  // Add other properties of the user object if available
}

const Navbar = () => {
  // const { accessToken, user } = useAppSelector((store) => ({
  //   accessToken: store.user.accessToken,
  //   user: store.user.user as User,
  // }));
  const user = useAppSelector((store) => store.user)
  const { notificaitonListApi, notificaitonCountApi } = API_ROUTES;
  const [notificationList, setNotificationList] = useState<
    BookingNotification[] | null
  >();
  const [notificationCount, setNotificationCount] = useState<
    NotificationCount | null
  >();
  const { isChanged } = useAppSelector((store) => store.form);
  const { refreshToken } = useAppSelector((store) => store.user);
  const avatar = useAppSelector((store) => store.user.avatar);

  const [modal, setModal] = useState<boolean>(false);
  const [navigateTo, setNavigtateTo] = useState<string>("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const authRoutes = [
    "/checkemail",
    "/signup",
    "/login",
    "/forget/password",
    "/reset-password",
    "/checkemail",
  ];

  const location = useLocation();
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const path = location.pathname;

  useEffect(() => {
    refreshToken && getNotifications();
  }, [user, refreshToken, notificaitonListApi]);

  useEffect(() => {
    if (!refreshToken) return;
    getNotificationsCount();
    const interval = setInterval(() => {
      getNotificationsCount();
    }, 300000);
    return () => clearInterval(interval);
  }, [refreshToken]);

  const getNotifications = async () => {
    // Check inside the effect to maintain hook consistency
    try {
      const result = await GET(`${notificaitonListApi}`, refreshToken);
      setNotificationList(result.data);
    } catch (error) {
      console.log('error in notification list: ', error);
    }
  };

  const closeSidebar = () => setOpenSideBar(false);
  const openSidebar = () => setOpenSideBar(true);
  // if (authRoutes.includes(path)) {
  //   return null;
  // }

  const logoutUser = () => {
    dispatch(currentBusinessSave(null))
    dispatch(logout());
    navigate("/login");
    closeSidebar()
  };

  const handleModalOkay = () => {
    setModal(false);
  };

  const handleModalCancel = () => {
    dispatch(formStateChange(false));
    setModal(false);
    navigate(navigateTo);
  };

  const tryToNavigate = (path: string) => {
    if (isChanged) {
      setNavigtateTo(path);
      setModal(true);
    } else {
      navigate(path);
    }
  };

  const getNotificationsCount = async () => {
    try {
      const result = await GET(`${notificaitonCountApi}`, refreshToken);
      if (result?.data?.futurePayment) {
        dispatch(upadateFuturePayments(result?.data?.futurePayment))
      }
      if (!result?.data?.applicatoin_access) {
        dispatch(upadateApplicationAccess(false))
      } else {
        //if admin manually on toggle show options again
        if (result?.data?.applicatoin_access) {
          dispatch(upadateApplicationAccess(true))
        }
        //if count same as previous no update state
      }
      if (notificationCount?.count != result?.data?.count) {
        setNotificationCount(result?.data)
      }
    } catch (error) {
      console.log('error in notification count: ', error);
    }
  };

  return (
    <>
      {!authRoutes.includes(path) && (
        <div className=" bg-white sticky top-0 z-40  px-8 pt-5 pb-4 md:pb-3 lg:pb-0">

          <nav className="container mx-auto flex  justify-between items-center   ">
            {/* Navbar Links */}
            <ul className=" hidden lg:flex  md:w-7/12 h-10 justify-around  items-center text-gray-600 font-semibold  rounded-full"></ul>

            {/* Notification Icon and User Image */}
            <div className=" gap-6 items-center hidden lg:flex ">
              {!user.accessToken ? (
                <Link
                  className="text-center inline-block px-6 bg-primary-red text-white  rounded-lg py-2"
                  to="/login"
                >
                  Login
                </Link>
              ) : (
                <div className="relative flex items-center cursor-pointer " ref={dropdownRef}>
                  {/* {user?.roles === "admin" &&
                  notificationList &&
                  notificationList?.length > 0 && ( */}
                  {notificationList && <NotificationBell
                    getNotificationsCount={getNotificationsCount}
                    notificationCount={notificationCount}
                    notificationList={notificationList}
                    getNotifications={getNotifications}
                  />}
                  {/* )} */}
                  <div
                    className={`   p-1 font-semibold `}
                  >

                    {avatar ? (
                      <div onClick={() => {
                        setOpenDropdown(!openDropdown);
                      }} className="flex items-center gap-2">
                        <img
                          src={avatar}
                          alt="avatar"

                          className={`w-10 h-10 rounded-full object-cover ${openDropdown
                            ? "border-primary-red-button border-2"
                            : "border-white border-2"
                            }`}
                        />
                        <p>{user?.first_name}</p>
                        <MdOutlineKeyboardArrowDown size={24} />

                      </div>
                    ) :
                      <Button
                        className={`rounded-full shadow-md h-10 w-10 bg-primary-red-button text-sm text-white  font-semibold `}
                        onClick={() => {
                          setOpenDropdown(!openDropdown);
                        }}
                      >
                        {user?.first_name[0] ?? "H"}
                        {user?.last_name[0] ?? "O"}
                      </Button>
                    }



                  </div>

                  {openDropdown && (
                    <div className="absolute -right-2 -bottom-10 border-2 border-slate-200  mt-1 w-48 bg-white rounded-lg shadow-md z-30">
                      {/* Dropdown content goes here */}
                      <button
                        onClick={() => {
                          setOpenDropdown(false), navigate("/change-password");
                        }}
                        className="block px-4 py-2 text-gray-600  font-semibold text-center border-b-0"
                      >
                        <div className="flex gap-2 justify-center items-center text-black ">
                          <RiLockPasswordLine />
                          <p className="text-sm text-black">Change Password</p>
                        </div>
                      </button>
                      {/* <button
                      onClick={() => {
                        setOpenDropdown(false), logoutUser();
                      }}
                      className="block px-4 py-2 text-gray-600  font-semibold text-center"
                    >
                      <div className="flex justify-center items-center gap-2 hover:text-primary-red-button">
                        <HiOutlineLogout />
                        <p className="text-sm">Logout</p>
                      </div>
                    </button> */}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div
              onClick={() => {
                tryToNavigate("/");
              }}
              className=" items-center cursor-pointer lg:hidden block"
            >
              <img src={logo} alt="Logo" className="w-32 mr-4" />
            </div>
            {/* sidebar */}
            <div className="block lg:hidden">
              {!openSideBar && (
                <div onClick={openSidebar}>
                  <Bars />
                </div>
              )}
              {openSideBar && (
                <MobileSideBar
                  accessToken={user.accessToken}
                  closeSidebar={closeSidebar}
                  logoutUser={logoutUser}
                  notificationList={notificationList}
                  getNotificationsCount={getNotificationsCount}
                  notificationCount={notificationCount}
                  getNotifications={getNotifications}
                />
              )}
            </div>
          </nav>
        </div>

      )}
      {/* {modal && (
        <ChangesAlert
          isOpen={modal}
          title="Unsaved Changed"
          desc="You have unsaved changes. Are you sure you want to leave?"
          positiveButtonText="No, Stay"
          negativeButtonText="Yes, Leave"
          handleDiscardChanges={handleModalCancel}
          handleSaveChanges={handleModalOkay}
        />
      )} */}
      {openDropdown && (
        <div
          className="absolute top-0 right-0 left-0 bottom-0  z-20"
          onClick={() => setOpenDropdown(false)}
        >
          {" "}
        </div>
      )}
    </>
  );
};

export default Navbar;
